module.exports = __webpack_public_path__ + "img/6.b70b6f05.jpg";